export const VOUCHER_TYPE = {
    PAID_VOUCHER : 0,
    FREE_VOUCHER : 1
}